import Marquee from "react-fast-marquee";

const ITEMS = [
  "BEER EXPLAINED",
  "A TALK & TASTING",
  "SIX CONTRASTING STYLES",
];

export default function EditorialMarquee() {
  return (
    <div className="bg-[var(--gold)] text-[var(--bg)] py-4 border-y border-[rgba(26,43,31,0.2)]">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="font-display text-2xl sm:text-3xl mx-8 flex items-center gap-8">
            {t} <span className="text-lg">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
